import { useQuery } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { FileItem } from 'api/types';

interface UseFilesGalleryQueryParams {
  categoryIds: string[];
  searchText: string;
}

interface UseFilesGalleryQueryReturn {
  files: FileItem[];
  isLoading: boolean;
}

export function useFilesGalleryQuery({
  categoryIds,
  searchText,
}: UseFilesGalleryQueryParams): UseFilesGalleryQueryReturn {
  const { data, isLoading } = useQuery({
    queryKey: ['filesGallery', { categoryIds, searchText }],
    queryFn: () =>
      API_HANDLERS.FILES.GET_LIST({
        category_ids: categoryIds,
        ...(searchText ? { q: searchText } : {}),
      }),
    enabled: categoryIds.length > 0,
    refetchOnMount: 'always' as const,
  });

  return {
    files: data?.data?.data ?? [],
    isLoading: categoryIds.length > 0 && isLoading,
  };
}
